(function () {
  const MOBILE_QUERY = window.matchMedia("(max-width: 767px)");
  const HERO_HEIGHT_RATIO = 0.27;

  const SEAL_SELECTORS = [
    "#seal-subscriptions-widget",
    '[id*="seal-subscription"]',
    '[class*="sealsubs"]',
    '[data-seal-subscriptions]',
    ".sls-purchase-options",
    ".sls-widget-container",
  ];

  const BUNDLE_SELECTORS = [
    '[class*="foxkit-bundle"]',
    '[class*="foxkit-bundles"]',
    '[data-foxkit-bundle]',
    ".foxkit-bundles",
    ".f-bundles",
  ];

  const PROTECTED_SELECTORS =
    ".m-product-info--wrapper, .m-main-product--info, .m-main-product--wrapper, .rhh-pdp-below-fold, .rhh-product-purchase-zone, .rhh-product-bundle-explainer, .rhh-product-short-description, product-form, .m-product-form--main, .main-product__block-buy_buttons";

  function getHeroMaxPx() {
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    return Math.round(viewportHeight * HERO_HEIGHT_RATIO);
  }

  function clampHeroGallery(root) {
    if (!MOBILE_QUERY.matches || !root) return;

    const maxPx = getHeroMaxPx();
    const gallery = root.querySelector(".m-media-gallery__inner.m-product-media--slider__images");
    if (!gallery) return;

    gallery.style.setProperty("max-height", maxPx + "px", "important");
    gallery.style.setProperty("height", maxPx + "px", "important");

    if (gallery.swiper) {
      gallery.swiper.params.autoHeight = false;
      gallery.swiper.update();
    }
  }

  function centerSelectedSizeInTrack(track) {
    const checked = track.querySelector('input[type="radio"]:checked');
    const node = checked?.closest(".m-product-option--node");
    if (!node || track.clientWidth <= 0) return;

    const nodeCenter = node.offsetLeft + node.offsetWidth / 2;
    const targetScroll = nodeCenter - track.clientWidth / 2;
    const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
    track.scrollLeft = Math.min(Math.max(targetScroll, 0), maxScroll);
  }

  function centerAllSizeScrollTracks(root) {
    if (!MOBILE_QUERY.matches) return;
    root.querySelectorAll(".rhh-size-scroll-shell__track").forEach((track) => {
      centerSelectedSizeInTrack(track);
    });
  }

  function initSizeScrollShells(root) {
    if (!MOBILE_QUERY.matches) return;

    root.querySelectorAll(".rhh-size-scroll-shell").forEach((shell) => {
      const track = shell.querySelector(".rhh-size-scroll-shell__track");
      const prev = shell.querySelector(".rhh-size-scroll-shell__arrow--prev");
      const next = shell.querySelector(".rhh-size-scroll-shell__arrow--next");
      if (!track || !prev || !next) return;

      const updateArrows = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const canScroll = maxScroll > 4;
        shell.classList.toggle("rhh-size-scroll-shell--scrollable", canScroll);
        prev.hidden = !canScroll || track.scrollLeft <= 2;
        next.hidden = !canScroll || track.scrollLeft >= maxScroll - 2;
      };

      if (shell.dataset.rhhScrollInit !== "true") {
        shell.dataset.rhhScrollInit = "true";

        const scrollByAmount = () => Math.max(track.clientWidth * 0.55, 100);

        prev.addEventListener("click", () => {
          track.scrollBy({ left: -scrollByAmount(), behavior: "smooth" });
        });
        next.addEventListener("click", () => {
          track.scrollBy({ left: scrollByAmount(), behavior: "smooth" });
        });
        track.addEventListener("scroll", updateArrows, { passive: true });
        window.addEventListener("resize", updateArrows);

        centerSelectedSizeInTrack(track);

        if (track.scrollWidth > track.clientWidth + 4 && !shell.dataset.rhhWaggled) {
          shell.dataset.rhhWaggled = "true";
          track.animate(
            [
              { transform: "translateX(0)" },
              { transform: "translateX(-14px)" },
              { transform: "translateX(0)" },
            ],
            { duration: 500, easing: "ease-in-out" }
          );
        }
      }

      updateArrows();
    });
  }

  function syncSelectedSizeDisplay(root) {
    const sizeValue = root.querySelector("[data-rhh-selected-size]");
    if (!sizeValue) return;

    const sizeField = Array.from(root.querySelectorAll(".rhh-product-variant-atf [data-picker-field]")).find((field) => {
      const name = (field.dataset.optionName || "").toLowerCase();
      return name.includes("size");
    });

    if (sizeField?.dataset.selectedValue) {
      sizeValue.textContent = sizeField.dataset.selectedValue;
    }
  }

  function refreshPurchaseUi(root) {
    syncSelectedSizeDisplay(root);
    initSizeScrollShells(root);
    centerAllSizeScrollTracks(root);
  }

  function syncTrustAvailability(root, variant) {
    const hasVariant = Boolean(variant);
    if (!hasVariant) return;

    const isAvailable = Boolean(variant.available);
    const soldOutText = window.MinimogStrings?.soldOut || "Sold Out";

    root.querySelectorAll("[data-rhh-trust-availability]").forEach((label) => {
      const shipText = label.dataset.rhhShipText || "Ships today";
      label.textContent = isAvailable ? shipText : soldOutText;
    });
    root.querySelectorAll("[data-rhh-trust-availability-dot]").forEach((dot) => {
      dot.classList.toggle("rhh-product-trust-strip__dot--out", !isAvailable);
    });

    root.querySelectorAll("[data-rhh-hero-availability-badge]").forEach((badge) => {
      const heroLabel = badge.querySelector("[data-rhh-hero-availability]");
      const heroDot = badge.querySelector("[data-rhh-hero-availability-dot]");
      if (heroLabel) {
        heroLabel.textContent = isAvailable
          ? badge.dataset.rhhShipText || "Ships today"
          : badge.dataset.rhhSoldoutText || soldOutText;
      }
      if (heroDot) {
        heroDot.classList.toggle("rhh-pdp-instock-badge__dot--out", !isAvailable);
      }
    });
  }

  function parsePx(value) {
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : 0;
  }

  function getTitleAvailableWidth(title, titleRow) {
    if (!title) return 0;

    const titleWidth = title.clientWidth;
    if (titleWidth > 0) return titleWidth;

    if (titleRow) {
      const rowStyle = window.getComputedStyle(titleRow);
      const paddingLeft = parsePx(rowStyle.paddingLeft);
      const paddingRight = parsePx(rowStyle.paddingRight);
      let available = titleRow.clientWidth - paddingLeft - paddingRight;

      const wishlist = titleRow.querySelector(".m-product-wishlist");
      if (wishlist && wishlist.offsetParent !== null) {
        const wishlistStyle = window.getComputedStyle(wishlist);
        available -=
          wishlist.offsetWidth +
          parsePx(wishlistStyle.marginLeft) +
          parsePx(wishlistStyle.marginRight);
      }

      if (available > 0) return available;
    }

    return title.parentElement?.clientWidth || 0;
  }

  function getTitleMaxSize(title, isMobile) {
    const prevSize = title.style.getPropertyValue("font-size");
    const prevVar = title.style.getPropertyValue("--rhh-title-fit-size");
    title.style.removeProperty("font-size");
    title.style.removeProperty("--rhh-title-fit-size");

    let maxSize = parsePx(window.getComputedStyle(title).fontSize);
    if (maxSize <= 0) maxSize = isMobile ? 24 : 30;

    if (prevSize) title.style.setProperty("font-size", prevSize);
    if (prevVar) title.style.setProperty("--rhh-title-fit-size", prevVar);
    return maxSize;
  }

  const REFERENCE_TITLE = "Ultra Premium Coarse Orchard Grass";

  function applyTitleFitSize(title, sizePx) {
    const px = sizePx + "px";
    title.style.setProperty("font-size", px, "important");
    title.style.setProperty("--rhh-title-fit-size", px);
  }

  function fitSingleLineTitleSize(title, titleRow, isMobile) {
    const minSize = isMobile ? 10 : 11;
    const maxSize = getTitleMaxSize(title, isMobile);
    const availableWidth = getTitleAvailableWidth(title, titleRow);
    if (!availableWidth) return null;

    title.style.width = "100%";
    title.style.whiteSpace = "nowrap";
    title.style.overflow = "visible";
    title.style.textOverflow = "clip";
    title.classList.remove("rhh-product-title--wrap");

    let low = minSize;
    let high = maxSize;
    let best = minSize;

    while (high - low > 0.25) {
      const mid = (low + high) / 2;
      applyTitleFitSize(title, mid);

      if (title.scrollWidth <= availableWidth + 0.5) {
        best = mid;
        low = mid;
      } else {
        high = mid;
      }
    }

    const finalSize = Math.round(best * 2) / 2;
    applyTitleFitSize(title, finalSize);

    let fittedSize = finalSize;
    if (title.scrollWidth > availableWidth + 0.5) {
      fittedSize = Math.max(
        minSize,
        Math.floor(((finalSize * availableWidth) / title.scrollWidth) * 2) / 2
      );
      applyTitleFitSize(title, fittedSize);
    }

    title.style.overflow = "hidden";
    return fittedSize;
  }

  function fitProductTitle(root) {
    const title = root.querySelector("h1.rhh-product-title");
    const titleRow = root.querySelector(".rhh-product-title-row");
    if (!title) return;

    const isMobile = MOBILE_QUERY.matches;
    const availableWidth = getTitleAvailableWidth(title, titleRow);
    if (!availableWidth) return;

    const originalText = title.textContent;
    title.textContent = REFERENCE_TITLE;
    const referenceSize = fitSingleLineTitleSize(title, titleRow, isMobile);
    title.textContent = originalText;

    if (!referenceSize) return;

    const shouldWrap =
      originalText.length > REFERENCE_TITLE.length ||
      (() => {
        applyTitleFitSize(title, referenceSize);
        title.style.whiteSpace = "nowrap";
        title.style.overflow = "visible";
        const overflows = title.scrollWidth > availableWidth + 0.5;
        title.style.overflow = "hidden";
        return overflows;
      })();

    if (shouldWrap) {
      title.classList.add("rhh-product-title--wrap");
      title.style.whiteSpace = "normal";
      title.style.overflow = "visible";
      title.style.textOverflow = "clip";
      applyTitleFitSize(title, referenceSize);
      title.dataset.rhhFittedTitleSize = referenceSize + "px";
      return;
    }

    const fittedSize = fitSingleLineTitleSize(title, titleRow, isMobile);
    if (fittedSize) {
      title.dataset.rhhFittedTitleSize = fittedSize + "px";
    }
  }

  function refreshHookSupplementExpand(block) {
    const textEl = block.querySelector(".rhh-product-hook-supplement__text");
    const toggle = block.querySelector(".rhh-product-hook-supplement__toggle");
    if (!textEl || !toggle) return;

    const isExpanded = block.classList.contains("rhh-product-hook-supplement--expanded");
    const overflows = textEl.scrollHeight > textEl.clientHeight + 1;

    if (isExpanded) {
      toggle.hidden = false;
      toggle.textContent = "see less";
      toggle.setAttribute("aria-expanded", "true");
      return;
    }

    if (overflows) {
      toggle.hidden = false;
      toggle.textContent = "...see more";
      toggle.setAttribute("aria-expanded", "false");
    } else {
      toggle.hidden = true;
      block.classList.remove("rhh-product-hook-supplement--expanded");
    }
  }

  function initHookSupplementExpand(root) {
    root.querySelectorAll(".rhh-product-hook-supplement--expandable").forEach((block) => {
      const textEl = block.querySelector(".rhh-product-hook-supplement__text");
      if (!textEl) return;

      let toggle = block.querySelector(".rhh-product-hook-supplement__toggle");
      if (!toggle) {
        toggle = document.createElement("button");
        toggle.type = "button";
        toggle.className = "rhh-product-hook-supplement__toggle";
        toggle.hidden = true;
        toggle.setAttribute("aria-expanded", "false");
        block.appendChild(toggle);

        toggle.addEventListener("click", () => {
          const expanded = block.classList.toggle("rhh-product-hook-supplement--expanded");
          toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
          toggle.textContent = expanded ? "see less" : "...see more";
        });
      }

      refreshHookSupplementExpand(block);

      if (block.dataset.rhhExpandObserved === "true") return;
      block.dataset.rhhExpandObserved = "true";

      if (typeof ResizeObserver !== "undefined") {
        const observer = new ResizeObserver(() => refreshHookSupplementExpand(block));
        observer.observe(textEl);
      }
    });
  }

  function shouldSkipHideTarget(node) {
    if (!node) return true;
    if (node.matches(PROTECTED_SELECTORS)) return true;
    if (node.closest(".rhh-pdp-below-fold, .rhh-pdp-instock-badge, .rhh-pdp-bundle-badge, .rhh-pdp-hero-badges, .rhh-product-bundle-explainer, .rhh-product-short-description")) {
      return true;
    }
    if (node.querySelector(".rhh-product-purchase-zone, .rhh-product-purchase-stack, product-form")) {
      return true;
    }
    return false;
  }

  function hideNode(node) {
    if (shouldSkipHideTarget(node)) return;
    node.classList.add("rhh-pdp-mobile-hidden");
    node.setAttribute("aria-hidden", "true");
  }

  function hideFoxkitBundleBanners(root) {
    root.querySelectorAll("div, section, aside, article").forEach((node) => {
      if (shouldSkipHideTarget(node)) return;

      const text = (node.textContent || "").replace(/\s+/g, " ").trim();
      if (text.includes("Bundle & Save") && text.includes("Add 2 or more")) {
        hideNode(node);
      }
    });
  }

  function hideSealPurchaseOptions(root) {
    if (!root) return;

    SEAL_SELECTORS.forEach((selector) => {
      root.querySelectorAll(selector).forEach((node) => hideNode(node));
    });
  }

  function hideInjectedWidgets(root) {
    if (!root) return;

    hideSealPurchaseOptions(root);

    if (!MOBILE_QUERY.matches) return;

    BUNDLE_SELECTORS.forEach((selector) => {
      root.querySelectorAll(selector).forEach((node) => hideNode(node));
    });

    hideFoxkitBundleBanners(root);
  }

  function destroyDesktopScrollMediaSync(root) {
    if (root._rhhScrollMediaObservers) {
      root._rhhScrollMediaObservers.forEach((observer) => observer.disconnect());
      root._rhhScrollMediaObservers = null;
    }
    if (root._rhhScrollMediaCleanup) {
      root._rhhScrollMediaCleanup();
      root._rhhScrollMediaCleanup = null;
    }
    root._rhhScrollMediaState = null;
  }

  function whenMediaSwiperReady(root, callback) {
    const attach = () => {
      const swiperEl = root.querySelector(".m-media-gallery__inner.m-product-media--slider__images");
      const swiper = swiperEl?.swiper;
      if (!swiper) return false;
      callback(swiper);
      return true;
    };

    if (attach()) return;

    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (attach() || attempts >= 40) clearInterval(timer);
    }, 150);
  }

  function initDesktopScrollMediaSync(root) {
    destroyDesktopScrollMediaSync(root);
    if (MOBILE_QUERY.matches) return;

    const features = root.querySelector(".rhh-product-features-benefits");
    const description = root.querySelector(".rhh-product-short-description");
    if (!features && !description) return;

    const SLIDE_DEFAULT = 0;
    const SLIDE_DESCRIPTION = 1;
    const SLIDE_FEATURES = 2;
    const FEATURES_TRIGGER_RATIO = 0.26;
    const DESCRIPTION_TRIGGER_RATIO = 0.34;

    const state = {
      features: false,
      description: false,
      swiper: null,
      lastIndex: null,
    };
    root._rhhScrollMediaState = state;

    const applySlide = () => {
      if (!state.swiper) return;

      let index = SLIDE_DEFAULT;
      if (state.description) index = SLIDE_DESCRIPTION;
      else if (state.features) index = SLIDE_FEATURES;

      if (state.lastIndex === index) return;
      state.lastIndex = index;

      const method = state.swiper.params?.loop ? "slideToLoop" : "slideTo";
      if (typeof state.swiper[method] !== "function") return;
      if (state.swiper.slides.length <= index) return;

      state.swiper[method](index, 450);
    };

    const evaluateScrollMedia = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const featuresLine = viewportHeight * FEATURES_TRIGGER_RATIO;
      const descriptionLine = viewportHeight * DESCRIPTION_TRIGGER_RATIO;

      state.features = features
        ? features.getBoundingClientRect().top <= featuresLine
        : false;
      state.description = description
        ? description.getBoundingClientRect().top <= descriptionLine
        : false;

      applySlide();
    };

    const onScrollOrResize = () => {
      if (root._rhhScrollMediaRaf) cancelAnimationFrame(root._rhhScrollMediaRaf);
      root._rhhScrollMediaRaf = requestAnimationFrame(evaluateScrollMedia);
    };

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize, { passive: true });
    root._rhhScrollMediaCleanup = () => {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
      if (root._rhhScrollMediaRaf) cancelAnimationFrame(root._rhhScrollMediaRaf);
      root._rhhScrollMediaRaf = null;
    };

    whenMediaSwiperReady(root, (swiper) => {
      state.swiper = swiper;
      state.lastIndex = null;
      evaluateScrollMedia();
    });

    evaluateScrollMedia();
  }

  function init() {
    const root = document.querySelector(".rhh-main-product");
    if (!root) return;

    root.querySelectorAll(".rhh-pdp-mobile-hidden").forEach((node) => {
      if (shouldSkipHideTarget(node)) {
        node.classList.remove("rhh-pdp-mobile-hidden");
        node.removeAttribute("aria-hidden");
      }
    });

    const mediaGallery = root.querySelector("media-gallery");

    hideInjectedWidgets(root);
    clampHeroGallery(root);
    fitProductTitle(root);
    initHookSupplementExpand(root);
    initDesktopScrollMediaSync(root);
    refreshPurchaseUi(root);
    setTimeout(() => hideSealPurchaseOptions(root), 1500);
    setTimeout(() => hideSealPurchaseOptions(root), 4000);
    setTimeout(() => hideInjectedWidgets(root), 1500);
    setTimeout(() => hideInjectedWidgets(root), 4000);

    const variantPicker = root.querySelector("variant-picker");
    if (variantPicker) {
      variantPicker.addEventListener("change", () => {
        refreshPurchaseUi(root);
        root.querySelectorAll(".rhh-size-scroll-shell__track").forEach((track) => {
          const checked = track.querySelector('input[type="radio"]:checked');
          const node = checked?.closest(".m-product-option--node");
          if (!node) return;
          const nodeLeft = node.offsetLeft;
          const nodeRight = nodeLeft + node.offsetWidth;
          if (nodeLeft < track.scrollLeft) {
            track.scrollLeft = Math.max(nodeLeft - 8, 0);
          } else if (nodeRight > track.scrollLeft + track.clientWidth) {
            track.scrollLeft = nodeRight - track.clientWidth + 8;
          }
        });
        initSizeScrollShells(root);
      });

      const variantUiObserver = new MutationObserver(() => {
        refreshPurchaseUi(root);
      });
      variantUiObserver.observe(variantPicker, {
        attributes: true,
        subtree: true,
        attributeFilter: ["data-selected-value"],
      });
    }

    if (mediaGallery) {
      const mediaObserver = new MutationObserver(() => {
        clampHeroGallery(root);
      });
      mediaObserver.observe(mediaGallery, { attributes: true, attributeFilter: ["data-media-loading"] });
    }

    if (typeof MinimogEvents !== "undefined" && MinimogTheme?.pubSubEvents?.variantChange) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (event) => {
        if (event.data?.sectionId !== root.dataset.sectionId) return;
        syncTrustAvailability(root, event.data?.variant);
      });
    }

    const title = root.querySelector("h1.rhh-product-title");
    const titleRow = root.querySelector(".rhh-product-title-row");
    if (typeof ResizeObserver !== "undefined") {
      const titleObserver = new ResizeObserver(() => fitProductTitle(root));
      if (titleRow) titleObserver.observe(titleRow);
      if (title) titleObserver.observe(title);
    }

    if (document.fonts?.ready) {
      document.fonts.ready
        .then(() => {
          fitProductTitle(root);
          initHookSupplementExpand(root);
        })
        .catch(() => {});
    }

    window.addEventListener("resize", () => {
      clampHeroGallery(root);
      fitProductTitle(root);
      initHookSupplementExpand(root);
    });
    window.visualViewport?.addEventListener("resize", () => {
      clampHeroGallery(root);
      fitProductTitle(root);
      initHookSupplementExpand(root);
    });
    window.addEventListener("load", () => {
      clampHeroGallery(root);
      fitProductTitle(root);
      initHookSupplementExpand(root);
      refreshPurchaseUi(root);
    });
    setTimeout(() => {
      clampHeroGallery(root);
      fitProductTitle(root);
      initHookSupplementExpand(root);
      refreshPurchaseUi(root);
    }, 250);
    setTimeout(() => {
      clampHeroGallery(root);
      fitProductTitle(root);
      initHookSupplementExpand(root);
      refreshPurchaseUi(root);
      initDesktopScrollMediaSync(root);
    }, 1000);

    MOBILE_QUERY.addEventListener("change", () => {
      if (MOBILE_QUERY.matches) {
        destroyDesktopScrollMediaSync(root);
        hideInjectedWidgets(root);
        clampHeroGallery(root);
        fitProductTitle(root);
        initHookSupplementExpand(root);
      } else {
        root.querySelectorAll(".rhh-pdp-mobile-hidden").forEach((node) => {
          node.classList.remove("rhh-pdp-mobile-hidden");
          node.removeAttribute("aria-hidden");
        });
        const gallery = root.querySelector(".m-media-gallery__inner.m-product-media--slider__images");
        if (gallery) {
          gallery.style.removeProperty("max-height");
          gallery.style.removeProperty("height");
        }
        fitProductTitle(root);
        initHookSupplementExpand(root);
        initDesktopScrollMediaSync(root);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
